var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductPlaceholderImageBig = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 148,
    height: 148,
    rx: 3,
    fill: "white",
    stroke: "#F4F5FA",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1004_15956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 1.17333,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1004_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2572 24.7661C49.2918 24.3198 49.6605 24.0225 50.1082 24.0225H97.5118C97.9544 24.0225 98.3192 24.3046 98.3601 24.7453C99.1569 33.3294 106.602 115.607 99.8694 122.379C99.7987 122.45 99.7342 122.485 99.6404 122.521C90.9692 125.781 55.702 126.628 48.1518 122.578C48.0162 122.505 47.9306 122.424 47.8621 122.286C42.6619 111.823 48.5979 33.2584 49.2572 24.7661Z",
    fill: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.8361 65.3651C56.8346 65.1269 57.0272 64.9331 57.2653 64.9331H101.354C101.354 64.9331 103.536 93.5145 102.712 103.51L57.512 103.839C57.2748 103.841 57.0812 103.65 57.0796 103.413L56.8361 65.3651Z",
    fill: "#5D6D98"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51.6589,
    y: 38.0854,
    width: 19.9855,
    height: 3.94776,
    rx: 0.429202,
    fill: "#5D6D98"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 51.6589,
    y: 44.9949,
    width: 26.6474,
    height: 2.96082,
    rx: 0.429202,
    fill: "#5D6D98"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductPlaceholderImageBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product-placeholder-image-big.fbe9e7b55eb256313d344fff7556cac8.svg";